import '@/styles/globals.css'
import '@/styles/rich-text.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Markazi_Text, Vazirmatn } from 'next/font/google'

const sans = Vazirmatn({
    subsets: ['arabic', 'latin'],
    display: 'swap'
})

const heading = Markazi_Text({
    subsets: ['arabic', 'latin'],
    display: 'swap'
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-heading:${heading.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <meta name='viewport' content='width=device-width, initial-scale=1' />
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <Component {...pageProps} />
        </div>
    )
}

export default App
